'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _QuestionMarkCircled = require('./QuestionMarkCircled');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_QuestionMarkCircled).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/QuestionMarkCircled/index.js
// module id = 1264
// module chunks = 1